import * as React from 'react';
import { TableCell } from '../TableCell';
import * as styles from './TableHeader.css';
import { AuctionPointsHint } from './components/AuctionPointsHint';

interface ITableHeaderProps {
  contentColTitle: string;
  pointsColTitle: string;
  priceColTitle: string;
  durationCol: boolean;
  auctionPointsCol: boolean;
  isPointsHintAvailable: boolean;
}

export const TableHeader = (props: ITableHeaderProps) => {
  const { contentColTitle, pointsColTitle, priceColTitle, durationCol, auctionPointsCol, isPointsHintAvailable } =
    props;

  return (
    <thead>
      <tr className={styles['header']}>
        <TableCell header>{contentColTitle}</TableCell>

        {durationCol && <TableCell header>Срок</TableCell>}

        {auctionPointsCol && (
          <TableCell header>
            <div className={styles['points_cell']}>
              {pointsColTitle}

              {isPointsHintAvailable && (
                <div className={styles['points_hint']}>
                  <AuctionPointsHint />
                </div>
              )}
            </div>
          </TableCell>
        )}

        <TableCell header>{priceColTitle}</TableCell>
      </tr>
    </thead>
  );
};
